// Traduções do módulo de Colheita — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'colheita.title': 'Colheita',
    'colheita.eyebrow': 'Logística',
    'colheita.aba.dashboard': 'Dashboard',
    'colheita.aba.protheus': 'Colheitas do Protheus',
    'colheita.aba.alertas': 'Relatório de Alertas',

    'colheita.filtros.de': 'De',
    'colheita.filtros.ate': 'Até',
    'colheita.filtros.buscaLabel': 'Busca',
    'colheita.filtros.busca': 'Máquina, operador, contrato, medição',
    'colheita.filtros.cliente': 'Cliente HUB',
    'colheita.filtros.contrato': 'Contrato',
    'colheita.filtros.dupla': 'Dupla',
    'colheita.filtros.servico': 'Serviço',
    'colheita.filtros.maquina': 'Máquina',
    'colheita.filtros.operador': 'Operador',
    'colheita.filtros.alerta': 'Alerta',

    'colheita.secao.numeros': 'Números da colheita',
    'colheita.secao.numerosDetalhe': 'Medições lançadas no Protheus, que chegam quando o contrato acaba. Última leitura em {{quando}}',
    'colheita.secao.numerosSemLeitura': 'Medições lançadas no Protheus, que chegam quando o contrato acaba',
    'colheita.secao.cargas': 'Solicitadas e atendidas',
    'colheita.secao.cargasDetalhe': 'Programação de colheita da Frente, em tempo real',
    'colheita.ind.hectares': 'Hectares',
    'colheita.ind.hectaresHint_one': 'Área de {{count}} medição do período',
    'colheita.ind.hectaresHint_other': 'Área das {{count}} medições do período',
    'colheita.ind.maquinas': 'Máquinas',
    'colheita.ind.maquinasHint': 'Máquinas com medição no período, sem as linhas de ajuste do Protheus',
    'colheita.ind.contratos': 'Contratos',
    'colheita.ind.contratosHint': 'Contratos com medição no período',
    'colheita.ind.dias': 'Média de dias para finalizar um contrato',
    'colheita.ind.diasHint': 'Por contrato, a data final menos a data inicial das medições do Protheus',
    'colheita.dash.hectaresPorCliente': 'Hectares por cliente',
    'colheita.dash.maquinasPorCliente': 'Máquinas por cliente',
    'colheita.dash.contratosPorCliente': 'Contratos por cliente',
    'colheita.dash.diasPorCliente': 'Média de dias por cliente',
    'colheita.dash.semCliente': 'Sem cliente',
    'colheita.dash.semMedicao': 'Nenhuma medição do Protheus no período',
    'colheita.dash.porMaquina': 'Hectares por máquina',
    'colheita.dash.porOperador': 'Hectares por operador',
    'colheita.tab.maquina': 'Máquina',
    // Os títulos das tabelas estreitas do Dashboard levam o hífen opcional, que só
    // aparece quando a coluna não comporta a palavra inteira (28/10/2026).
    'colheita.tab.hectares': 'Hec\u00ADta\u00ADres',
    'colheita.tab.contratos': 'Con\u00ADtra\u00ADtos',
    'colheita.tab.operadores': 'Ope\u00ADra\u00ADdo\u00ADres',
    'colheita.tab.medicoes': 'Me\u00ADdi\u00ADções',
    'colheita.tab.maquinasCol': 'Má\u00ADqui\u00ADnas',
    'colheita.tab.maquinas_one': '{{count}} máquina',
    'colheita.tab.maquinas_other': '{{count}} máquinas',
    'colheita.tab.operadoresTotal_one': '{{count}} operador',
    'colheita.tab.operadoresTotal_other': '{{count}} operadores',
    'colheita.tab.semOperador': 'Sem operador',
    'colheita.local.titulo': 'Localização atual da máquina',
    'colheita.local.placa': 'Placa',
    'colheita.local.local': 'Local',
    'colheita.local.data': 'Data',
    'colheita.local.cliente': 'Cliente',
    'colheita.local.garagem': 'Garagem',
    'colheita.local.vazio': 'Nenhuma máquina com viagem concluída no Transporte de Máquina',
    'colheita.excel.dica.maquina': 'Baixa os hectares por máquina com os filtros da tela',
    'colheita.excel.dica.operador': 'Baixa os hectares por operador com os filtros da tela',
    'colheita.excel.dica.localizacao': 'Baixa onde cada máquina está agora, pela última viagem concluída do Transporte de Máquina. Só o filtro de Máquina vale',
    'colheita.excel.dica.programacao': 'Baixa as cargas solicitadas e atendidas por operador com os filtros da tela',
    'colheita.excel.vazio': 'Não há linhas para baixar com os filtros da tela',

    'colheita.contrato.foraDoHub': 'FORA DO HUB',
    'colheita.contrato.erp': 'Contrato no Protheus: {{contrato}}',
    'colheita.contrato.semErp': 'O Protheus não informou o contrato',

    'colheita.ind.solicitadas': 'Cargas solicitadas',
    'colheita.ind.solicitadasHint_one': 'Soma das cargas de {{count}} programação de colheita da Frente, lançada ou não',
    'colheita.ind.solicitadasHint_other': 'Soma das cargas de {{count}} programações de colheita da Frente, lançadas ou não',
    'colheita.ind.atendidas': 'Cargas atendidas',
    'colheita.ind.atendidasHint': 'O que a Frente lançou como atendido',
    'colheita.ind.naoAtendidas': 'Não atendidas',
    'colheita.ind.naoAtendidasHint': 'A diferença das programações lançadas abaixo do solicitado',
    'colheita.ind.pendentes': 'Pendentes de lançamento',
    'colheita.ind.pendentesHint': 'Programações que já passaram sem o atendido lançado',
    'colheita.ind.emAndamento': 'Em andamento',
    'colheita.ind.emAndamentoHint': 'Programações de hoje ou dos próximos dias',

    'colheita.serie.atendidas': 'Atendidas',
    'colheita.serie.emAndamento': 'Em andamento',
    'colheita.serie.pendentes': 'Pendentes',
    'colheita.serie.naoAtendidas': 'Não atendidas',

    'colheita.dash.porDia': 'Cargas solicitadas e atendidas por dia',
    'colheita.dash.porDiaHint': 'Pela data da programação de colheita da Frente. A altura da coluna é o solicitado.',
    'colheita.dash.semDados': 'Nenhuma programação de colheita no período',
    'colheita.serie.solicitadas': 'Solicitadas',
    'colheita.prog.titulo': 'Cargas solicitadas e atendidas por operador',
    'colheita.prog.total_one': '{{count}} linha',
    'colheita.prog.total_other': '{{count}} linhas',
    'colheita.prog.data': 'Data',
    'colheita.prog.equipe': 'Equipe',
    'colheita.prog.situacao': 'Situação',
    'colheita.prog.situacao.lancada': 'Lançada',
    'colheita.prog.situacao.pendente': 'Pendente',
    'colheita.prog.situacao.andamento': 'Em andamento',
    'colheita.prog.semEquipe': 'Sem equipe',
    'colheita.prog.rodape': 'Cada linha é um operador numa programação de colheita da Frente. As cargas são da programação inteira, que a Frente lança para a equipe, e a coluna Equipe diz quantas máquinas dividem esse número.',

    'colheita.relatorio.title': 'Medições lançadas no Protheus',
    'colheita.relatorio.count_one': '{{count}} medição',
    'colheita.relatorio.count_other': '{{count}} medições',
    'colheita.relatorio.maquinas_one': '{{count}} máquina',
    'colheita.relatorio.maquinas_other': '{{count}} máquinas',
    'colheita.relatorio.hint': 'O Protheus lança a medição quando o contrato acaba',
    'colheita.vazio': 'Nenhuma medição do Protheus no período',

    'colheita.grupo.periodo': 'Período',
    'colheita.grupo.maquina': 'Máquina',
    'colheita.grupo.protheus': 'Protheus',
    'colheita.col.inicio': 'Início',
    'colheita.col.fim': 'Fim',
    'colheita.col.contrato': 'Contrato',
    'colheita.col.cliente': 'Cliente',
    'colheita.col.produtor': 'Produtor',
    'colheita.col.produto': 'Serviço',
    'colheita.col.maquina': 'Máquina',
    'colheita.col.operador': 'Operador',
    'colheita.col.hectares': 'Hectares',
    'colheita.col.medicao': 'Medição',
    'colheita.col.lancamento': 'Lançada em',
    'colheita.col.dupla': 'Dupla',

    'colheita.alertas.title': 'Medições que não batem com a Frente',
    'colheita.alertas.count_one': '{{count}} alerta',
    'colheita.alertas.count_other': '{{count}} alertas',
    'colheita.alertas.conferidas_one': 'em {{count}} medição conferida',
    'colheita.alertas.conferidas_other': 'em {{count}} medições conferidas',
    'colheita.alertas.hint': 'Cada medição do Protheus contra a Frente de Trabalho: as datas pela primeira e a última programação de colheita do operador no contrato, e os hectares pelo Maquinário. Sem período: o alerta some quando o Protheus ou a Frente é corrigido',
    'colheita.alertas.vazio': 'Nenhuma medição diverge da Frente',
    'colheita.alertas.grupo.protheus': 'Protheus',
    'colheita.alertas.grupo.hub': 'Frente de Trabalho',
    'colheita.alertas.colAlerta': 'Alerta',
    'colheita.alertas.colSituacao': 'Status da frente',
    'colheita.alertas.colHubInicio': 'Primeira',
    'colheita.alertas.colHubFim': 'Última',
    'colheita.alertas.tipo.sem_programacao': 'Sem programação na Frente',
    'colheita.alertas.tipo.data_diverge': 'Data divergente',
    'colheita.alertas.tipo.fora_do_local': 'Máquina fora do local',
    'colheita.alertas.tipo.hectares_diverge': 'Hectares diferentes',
    'colheita.alertas.tipo.sem_frente': 'Sem frente no HUB',
    'colheita.alertas.hint.sem_programacao': 'A medição é de um contrato do HUB, mas nenhuma programação de colheita desse contrato na Frente tem este operador nem esta máquina',
    'colheita.alertas.hint.data_diverge': 'A data inicial ou a final da medição no Protheus não é o dia da primeira ou da última programação de colheita do operador neste contrato na Frente. A data que diverge fica em vermelho. Quando o nome do operador não casa, vale a máquina',
    'colheita.alertas.hint.fora_do_local': 'A última posição do rastreador da máquina passa do raio do local da última viagem do Transporte de Máquina em mais de 10 km. Posição de antes da chegada não conta',
    'colheita.alertas.hint.hectares_diverge': 'Os hectares da medição no Protheus não batem com a Q. Hectares da mesma máquina e do mesmo operador no Maquinário da Frente, e as medições da mesma linha somam. A medição com 0 hectare só alerta quando a frente está Finalizada ou Finalizada com pendência',
    'colheita.alertas.hint.sem_frente': 'Medição com data inicial de 16/10/2026 em diante que não se liga a nenhuma frente do HUB, nem pelo pivô nem pela planilha do ERP',
    'colheita.alertas.maquinas.title': 'Máquinas fora do local da última viagem',
    'colheita.alertas.maquinas.hint': 'A posição do rastreador contra o local de destino da última viagem concluída, o mesmo da Localização atual da máquina no Dashboard. Alerta quando a máquina passa do raio do local em mais de 10 km',
    'colheita.alertas.maquinas.vazio': 'Nenhuma máquina longe do local da última viagem',
    'colheita.alertas.maquinas.colMaquina': 'Máquina',
    'colheita.alertas.maquinas.colLocal': 'Local da última viagem',
    'colheita.alertas.maquinas.colChegada': 'Chegada',
    'colheita.alertas.maquinas.colDistancia': 'Distância',
    'colheita.alertas.maquinas.colPosicao': 'Posição do rastreador',
    'colheita.alertas.maquinas.colCliente': 'Cliente',
    'colheita.alertas.maquinas.colViagem': 'Viagem',
    'colheita.alertas.maquinas.km': '{{km}} km',
    'colheita.alertas.maquinas.raio': 'Raio do local {{km}} km',
    'colheita.alertas.maquinas.rodando': 'Foi rodando',
    'colheita.alertas.maquinas.mapa': 'Mapa',
    'colheita.alertas.maquinas.rastreador.ssx': 'SSX',
    'colheita.alertas.maquinas.rastreador.truckscontrol': 'Trucks Control',
    'colheita.alertas.maquinas.rastreador.aldeia': 'Aldeia',
    'colheita.alertas.grupo.hectares': 'Hectares',
    'colheita.alertas.colHaProtheus': 'Protheus',
    'colheita.alertas.colHaFrente': 'Frente',
    'colheita.alertas.medicoesSomadas_one': '{{count}} medição soma {{total}}',
    'colheita.alertas.medicoesSomadas_other': '{{count}} medições somam {{total}}',
    'colheita.alertas.linhasSomadas_one': '{{count}} linha do Maquinário',
    'colheita.alertas.linhasSomadas_other': '{{count}} linhas do Maquinário',
    'colheita.alertas.casadoPor.operador': 'Programações achadas pelo nome do operador',
    'colheita.alertas.casadoPor.maquina': 'Programações achadas pelo código da máquina, porque o nome do operador não casou',
    'colheita.alertas.programacoes_one': '{{count}} programação',
    'colheita.alertas.programacoes_other': '{{count}} programações',
  },
  en: {
    'colheita.title': 'Harvest',
    'colheita.eyebrow': 'Logistics',
    'colheita.aba.dashboard': 'Dashboard',
    'colheita.aba.protheus': 'Protheus harvests',
    'colheita.aba.alertas': 'Alerts report',

    'colheita.filtros.de': 'From',
    'colheita.filtros.ate': 'To',
    'colheita.filtros.buscaLabel': 'Search',
    'colheita.filtros.busca': 'Machine, operator, contract, measurement',
    'colheita.filtros.cliente': 'HUB customer',
    'colheita.filtros.contrato': 'Contract',
    'colheita.filtros.dupla': 'Team',
    'colheita.filtros.servico': 'Service',
    'colheita.filtros.maquina': 'Machine',
    'colheita.filtros.operador': 'Operator',
    'colheita.filtros.alerta': 'Alert',

    'colheita.secao.numeros': 'Harvest numbers',
    'colheita.secao.numerosDetalhe': 'Measurements recorded in Protheus, which arrive when the contract ends. Last read on {{quando}}',
    'colheita.secao.numerosSemLeitura': 'Measurements recorded in Protheus, which arrive when the contract ends',
    'colheita.secao.cargas': 'Requested and attended',
    'colheita.secao.cargasDetalhe': 'Harvest schedule of the work front, in real time',
    'colheita.ind.hectares': 'Hectares',
    'colheita.ind.hectaresHint_one': 'Area of {{count}} measurement in the period',
    'colheita.ind.hectaresHint_other': 'Area of the {{count}} measurements in the period',
    'colheita.ind.maquinas': 'Machines',
    'colheita.ind.maquinasHint': 'Machines with a measurement in the period, without the Protheus adjustment lines',
    'colheita.ind.contratos': 'Contracts',
    'colheita.ind.contratosHint': 'Contracts with a measurement in the period',
    'colheita.ind.dias': 'Average days to finish a contract',
    'colheita.ind.diasHint': 'Per contract, the end date minus the start date of the Protheus measurements',
    'colheita.dash.hectaresPorCliente': 'Hectares per customer',
    'colheita.dash.maquinasPorCliente': 'Machines per customer',
    'colheita.dash.contratosPorCliente': 'Contracts per customer',
    'colheita.dash.diasPorCliente': 'Average days per customer',
    'colheita.dash.semCliente': 'No customer',
    'colheita.dash.semMedicao': 'No Protheus measurement in the period',
    'colheita.dash.porMaquina': 'Hectares per machine',
    'colheita.dash.porOperador': 'Hectares per operator',
    'colheita.tab.maquina': 'Machine',
    'colheita.tab.hectares': 'Hec\u00ADtares',
    'colheita.tab.contratos': 'Con\u00ADtracts',
    'colheita.tab.operadores': 'Op\u00ADer\u00ADa\u00ADtors',
    'colheita.tab.medicoes': 'Mea\u00ADsure\u00ADments',
    'colheita.tab.maquinasCol': 'Ma\u00ADchines',
    'colheita.tab.maquinas_one': '{{count}} machine',
    'colheita.tab.maquinas_other': '{{count}} machines',
    'colheita.tab.operadoresTotal_one': '{{count}} operator',
    'colheita.tab.operadoresTotal_other': '{{count}} operators',
    'colheita.tab.semOperador': 'No operator',
    'colheita.local.titulo': 'Current machine location',
    'colheita.local.placa': 'Plate',
    'colheita.local.local': 'Location',
    'colheita.local.data': 'Date',
    'colheita.local.cliente': 'Customer',
    'colheita.local.garagem': 'Garage',
    'colheita.local.vazio': 'No machine with a finished trip in Machine Transport',
    'colheita.excel.dica.maquina': 'Downloads the hectares per machine with the current filters',
    'colheita.excel.dica.operador': 'Downloads the hectares per operator with the current filters',
    'colheita.excel.dica.localizacao': 'Downloads where each machine is now, by its last finished Machine Transport trip. Only the Machine filter applies',
    'colheita.excel.dica.programacao': 'Downloads the requested and attended loads per operator with the current filters',
    'colheita.excel.vazio': 'There are no rows to download with the current filters',

    'colheita.contrato.foraDoHub': 'OUTSIDE THE HUB',
    'colheita.contrato.erp': 'Contract in Protheus: {{contrato}}',
    'colheita.contrato.semErp': 'Protheus did not send the contract',

    'colheita.ind.solicitadas': 'Requested loads',
    'colheita.ind.solicitadasHint_one': 'Sum of the loads of {{count}} harvest schedule, recorded or not',
    'colheita.ind.solicitadasHint_other': 'Sum of the loads of {{count}} harvest schedules, recorded or not',
    'colheita.ind.atendidas': 'Attended loads',
    'colheita.ind.atendidasHint': 'What the work front recorded as attended',
    'colheita.ind.naoAtendidas': 'Not attended',
    'colheita.ind.naoAtendidasHint': 'The gap of the schedules recorded below the request',
    'colheita.ind.pendentes': 'Awaiting record',
    'colheita.ind.pendentesHint': 'Past schedules with no attended loads recorded',
    'colheita.ind.emAndamento': 'In progress',
    'colheita.ind.emAndamentoHint': 'Schedules for today or the next days',

    'colheita.serie.atendidas': 'Attended',
    'colheita.serie.emAndamento': 'In progress',
    'colheita.serie.pendentes': 'Awaiting record',
    'colheita.serie.naoAtendidas': 'Not attended',

    'colheita.dash.porDia': 'Requested and attended loads per day',
    'colheita.dash.porDiaHint': 'By the date of the harvest schedule. The column height is the request.',
    'colheita.dash.semDados': 'No harvest schedule in the period',
    'colheita.serie.solicitadas': 'Requested',
    'colheita.prog.titulo': 'Requested and attended loads per operator',
    'colheita.prog.total_one': '{{count}} row',
    'colheita.prog.total_other': '{{count}} rows',
    'colheita.prog.data': 'Date',
    'colheita.prog.equipe': 'Team',
    'colheita.prog.situacao': 'Status',
    'colheita.prog.situacao.lancada': 'Recorded',
    'colheita.prog.situacao.pendente': 'Awaiting record',
    'colheita.prog.situacao.andamento': 'In progress',
    'colheita.prog.semEquipe': 'No team',
    'colheita.prog.rodape': 'Each row is one operator in a harvest schedule. Loads belong to the whole schedule, recorded for the team, and the Team column says how many machines share that number.',

    'colheita.relatorio.title': 'Measurements recorded in Protheus',
    'colheita.relatorio.count_one': '{{count}} measurement',
    'colheita.relatorio.count_other': '{{count}} measurements',
    'colheita.relatorio.maquinas_one': '{{count}} machine',
    'colheita.relatorio.maquinas_other': '{{count}} machines',
    'colheita.relatorio.hint': 'Protheus records the measurement when the contract ends',
    'colheita.vazio': 'No Protheus measurement in the period',

    'colheita.grupo.periodo': 'Period',
    'colheita.grupo.maquina': 'Machine',
    'colheita.grupo.protheus': 'Protheus',
    'colheita.col.inicio': 'Start',
    'colheita.col.fim': 'End',
    'colheita.col.contrato': 'Contract',
    'colheita.col.cliente': 'Customer',
    'colheita.col.produtor': 'Producer',
    'colheita.col.produto': 'Service',
    'colheita.col.maquina': 'Machine',
    'colheita.col.operador': 'Operator',
    'colheita.col.hectares': 'Hectares',
    'colheita.col.medicao': 'Measurement',
    'colheita.col.lancamento': 'Recorded on',
    'colheita.col.dupla': 'Team',

    'colheita.alertas.title': 'Measurements that do not match the Work Front',
    'colheita.alertas.count_one': '{{count}} alert',
    'colheita.alertas.count_other': '{{count}} alerts',
    'colheita.alertas.conferidas_one': 'in {{count}} measurement checked',
    'colheita.alertas.conferidas_other': 'in {{count}} measurements checked',
    'colheita.alertas.hint': 'Each Protheus measurement against the Work Front: the dates by the first and last harvest schedule of the operator in the contract, and the hectares by the Machinery block. No period: the alert goes away when Protheus or the Work Front is fixed',
    'colheita.alertas.vazio': 'No measurement diverges from the Work Front',
    'colheita.alertas.grupo.protheus': 'Protheus',
    'colheita.alertas.grupo.hub': 'Work Front',
    'colheita.alertas.colAlerta': 'Alert',
    'colheita.alertas.colSituacao': 'Work front status',
    'colheita.alertas.colHubInicio': 'First',
    'colheita.alertas.colHubFim': 'Last',
    'colheita.alertas.tipo.sem_programacao': 'No schedule on the Work Front',
    'colheita.alertas.tipo.data_diverge': 'Date mismatch',
    'colheita.alertas.tipo.fora_do_local': 'Machine away from site',
    'colheita.alertas.tipo.hectares_diverge': 'Different hectares',
    'colheita.alertas.tipo.sem_frente': 'No work front in HUB',
    'colheita.alertas.hint.sem_programacao': 'The measurement belongs to a HUB contract, but no harvest schedule of that contract on the Work Front has this operator or this machine',
    'colheita.alertas.hint.data_diverge': 'The Protheus start or end date is not the day of the operator\'s first or last harvest schedule in this contract on the Work Front. The mismatching date is shown in red. When the operator name does not match, the machine is used',
    'colheita.alertas.hint.fora_do_local': 'The machine tracker\'s last position is more than 10 km beyond the radius of the site of its last Machine Transport trip. Positions from before arrival do not count',
    'colheita.alertas.hint.hectares_diverge': 'The Protheus hectares do not match the hectares of the same machine and operator in the Work Front Machinery block, and measurements on the same row add up. A measurement with 0 hectares only alerts when the work front is Finished or Finished with pending items',
    'colheita.alertas.hint.sem_frente': 'Measurement starting on or after 10/16/2026 that is not linked to any HUB work front, by pivot or by ERP sheet',
    'colheita.alertas.maquinas.title': 'Machines away from the site of their last trip',
    'colheita.alertas.maquinas.hint': 'The tracker position against the destination of the last finished trip, the same as the Current machine location on the Dashboard. Alerts when the machine is more than 10 km beyond the site radius',
    'colheita.alertas.maquinas.vazio': 'No machine far from the site of its last trip',
    'colheita.alertas.maquinas.colMaquina': 'Machine',
    'colheita.alertas.maquinas.colLocal': 'Site of the last trip',
    'colheita.alertas.maquinas.colChegada': 'Arrival',
    'colheita.alertas.maquinas.colDistancia': 'Distance',
    'colheita.alertas.maquinas.colPosicao': 'Tracker position',
    'colheita.alertas.maquinas.colCliente': 'Customer',
    'colheita.alertas.maquinas.colViagem': 'Trip',
    'colheita.alertas.maquinas.km': '{{km}} km',
    'colheita.alertas.maquinas.raio': 'Site radius {{km}} km',
    'colheita.alertas.maquinas.rodando': 'Drove itself',
    'colheita.alertas.maquinas.mapa': 'Map',
    'colheita.alertas.maquinas.rastreador.ssx': 'SSX',
    'colheita.alertas.maquinas.rastreador.truckscontrol': 'Trucks Control',
    'colheita.alertas.maquinas.rastreador.aldeia': 'Aldeia',
    'colheita.alertas.grupo.hectares': 'Hectares',
    'colheita.alertas.colHaProtheus': 'Protheus',
    'colheita.alertas.colHaFrente': 'Work Front',
    'colheita.alertas.medicoesSomadas_one': '{{count}} measurement adds up to {{total}}',
    'colheita.alertas.medicoesSomadas_other': '{{count}} measurements add up to {{total}}',
    'colheita.alertas.linhasSomadas_one': '{{count}} Machinery row',
    'colheita.alertas.linhasSomadas_other': '{{count}} Machinery rows',
    'colheita.alertas.casadoPor.operador': 'Schedules found by the operator name',
    'colheita.alertas.casadoPor.maquina': 'Schedules found by the machine code, because the operator name did not match',
    'colheita.alertas.programacoes_one': '{{count}} schedule',
    'colheita.alertas.programacoes_other': '{{count}} schedules',
  },
  es: {
    'colheita.title': 'Cosecha',
    'colheita.eyebrow': 'Logística',
    'colheita.aba.dashboard': 'Dashboard',
    'colheita.aba.protheus': 'Cosechas de Protheus',
    'colheita.aba.alertas': 'Informe de alertas',

    'colheita.filtros.de': 'Desde',
    'colheita.filtros.ate': 'Hasta',
    'colheita.filtros.buscaLabel': 'Búsqueda',
    'colheita.filtros.busca': 'Máquina, operador, contrato, medición',
    'colheita.filtros.cliente': 'Cliente HUB',
    'colheita.filtros.contrato': 'Contrato',
    'colheita.filtros.dupla': 'Dupla',
    'colheita.filtros.servico': 'Servicio',
    'colheita.filtros.maquina': 'Máquina',
    'colheita.filtros.operador': 'Operador',
    'colheita.filtros.alerta': 'Alerta',

    'colheita.secao.numeros': 'Números de la cosecha',
    'colheita.secao.numerosDetalhe': 'Mediciones registradas en Protheus, que llegan cuando termina el contrato. Última lectura el {{quando}}',
    'colheita.secao.numerosSemLeitura': 'Mediciones registradas en Protheus, que llegan cuando termina el contrato',
    'colheita.secao.cargas': 'Solicitadas y atendidas',
    'colheita.secao.cargasDetalhe': 'Programación de cosecha del frente, en tiempo real',
    'colheita.ind.hectares': 'Hectáreas',
    'colheita.ind.hectaresHint_one': 'Área de {{count}} medición del período',
    'colheita.ind.hectaresHint_other': 'Área de las {{count}} mediciones del período',
    'colheita.ind.maquinas': 'Máquinas',
    'colheita.ind.maquinasHint': 'Máquinas con medición en el período, sin las líneas de ajuste de Protheus',
    'colheita.ind.contratos': 'Contratos',
    'colheita.ind.contratosHint': 'Contratos con medición en el período',
    'colheita.ind.dias': 'Promedio de días para terminar un contrato',
    'colheita.ind.diasHint': 'Por contrato, la fecha final menos la fecha inicial de las mediciones de Protheus',
    'colheita.dash.hectaresPorCliente': 'Hectáreas por cliente',
    'colheita.dash.maquinasPorCliente': 'Máquinas por cliente',
    'colheita.dash.contratosPorCliente': 'Contratos por cliente',
    'colheita.dash.diasPorCliente': 'Promedio de días por cliente',
    'colheita.dash.semCliente': 'Sin cliente',
    'colheita.dash.semMedicao': 'Ninguna medición de Protheus en el período',
    'colheita.dash.porMaquina': 'Hectáreas por máquina',
    'colheita.dash.porOperador': 'Hectáreas por operador',
    'colheita.tab.maquina': 'Máquina',
    'colheita.tab.hectares': 'Hec\u00ADtá\u00ADreas',
    'colheita.tab.contratos': 'Con\u00ADtra\u00ADtos',
    'colheita.tab.operadores': 'Ope\u00ADra\u00ADdo\u00ADres',
    'colheita.tab.medicoes': 'Me\u00ADdi\u00ADcio\u00ADnes',
    'colheita.tab.maquinasCol': 'Má\u00ADqui\u00ADnas',
    'colheita.tab.maquinas_one': '{{count}} máquina',
    'colheita.tab.maquinas_other': '{{count}} máquinas',
    'colheita.tab.operadoresTotal_one': '{{count}} operador',
    'colheita.tab.operadoresTotal_other': '{{count}} operadores',
    'colheita.tab.semOperador': 'Sin operador',
    'colheita.local.titulo': 'Ubicación actual de la máquina',
    'colheita.local.placa': 'Placa',
    'colheita.local.local': 'Ubicación',
    'colheita.local.data': 'Fecha',
    'colheita.local.cliente': 'Cliente',
    'colheita.local.garagem': 'Garaje',
    'colheita.local.vazio': 'Ninguna máquina con viaje concluido en Transporte de Máquina',
    'colheita.excel.dica.maquina': 'Descarga las hectáreas por máquina con los filtros de la pantalla',
    'colheita.excel.dica.operador': 'Descarga las hectáreas por operador con los filtros de la pantalla',
    'colheita.excel.dica.localizacao': 'Descarga dónde está cada máquina ahora, por el último viaje concluido de Transporte de Máquina. Solo vale el filtro de Máquina',
    'colheita.excel.dica.programacao': 'Descarga las cargas solicitadas y atendidas por operador con los filtros de la pantalla',
    'colheita.excel.vazio': 'No hay filas para descargar con los filtros de la pantalla',

    'colheita.contrato.foraDoHub': 'FUERA DEL HUB',
    'colheita.contrato.erp': 'Contrato en Protheus: {{contrato}}',
    'colheita.contrato.semErp': 'Protheus no informó el contrato',

    'colheita.ind.solicitadas': 'Cargas solicitadas',
    'colheita.ind.solicitadasHint_one': 'Suma de las cargas de {{count}} programación de cosecha, registrada o no',
    'colheita.ind.solicitadasHint_other': 'Suma de las cargas de {{count}} programaciones de cosecha, registradas o no',
    'colheita.ind.atendidas': 'Cargas atendidas',
    'colheita.ind.atendidasHint': 'Lo que el frente registró como atendido',
    'colheita.ind.naoAtendidas': 'No atendidas',
    'colheita.ind.naoAtendidasHint': 'La diferencia de las programaciones registradas por debajo de lo solicitado',
    'colheita.ind.pendentes': 'Pendientes de registro',
    'colheita.ind.pendentesHint': 'Programaciones pasadas sin lo atendido registrado',
    'colheita.ind.emAndamento': 'En curso',
    'colheita.ind.emAndamentoHint': 'Programaciones de hoy o de los próximos días',

    'colheita.serie.atendidas': 'Atendidas',
    'colheita.serie.emAndamento': 'En curso',
    'colheita.serie.pendentes': 'Pendientes',
    'colheita.serie.naoAtendidas': 'No atendidas',

    'colheita.dash.porDia': 'Cargas solicitadas y atendidas por día',
    'colheita.dash.porDiaHint': 'Por la fecha de la programación de cosecha. La altura de la columna es lo solicitado.',
    'colheita.dash.semDados': 'Ninguna programación de cosecha en el período',
    'colheita.serie.solicitadas': 'Solicitadas',
    'colheita.prog.titulo': 'Cargas solicitadas y atendidas por operador',
    'colheita.prog.total_one': '{{count}} fila',
    'colheita.prog.total_other': '{{count}} filas',
    'colheita.prog.data': 'Fecha',
    'colheita.prog.equipe': 'Equipo',
    'colheita.prog.situacao': 'Situación',
    'colheita.prog.situacao.lancada': 'Registrada',
    'colheita.prog.situacao.pendente': 'Pendiente',
    'colheita.prog.situacao.andamento': 'En curso',
    'colheita.prog.semEquipe': 'Sin equipo',
    'colheita.prog.rodape': 'Cada fila es un operador en una programación de cosecha del Frente. Las cargas son de la programación entera, que el Frente registra para el equipo, y la columna Equipo dice cuántas máquinas dividen ese número.',

    'colheita.relatorio.title': 'Mediciones registradas en Protheus',
    'colheita.relatorio.count_one': '{{count}} medición',
    'colheita.relatorio.count_other': '{{count}} mediciones',
    'colheita.relatorio.maquinas_one': '{{count}} máquina',
    'colheita.relatorio.maquinas_other': '{{count}} máquinas',
    'colheita.relatorio.hint': 'Protheus registra la medición cuando termina el contrato',
    'colheita.vazio': 'Ninguna medición de Protheus en el período',

    'colheita.grupo.periodo': 'Período',
    'colheita.grupo.maquina': 'Máquina',
    'colheita.grupo.protheus': 'Protheus',
    'colheita.col.inicio': 'Inicio',
    'colheita.col.fim': 'Fin',
    'colheita.col.contrato': 'Contrato',
    'colheita.col.cliente': 'Cliente',
    'colheita.col.produtor': 'Productor',
    'colheita.col.produto': 'Servicio',
    'colheita.col.maquina': 'Máquina',
    'colheita.col.operador': 'Operador',
    'colheita.col.hectares': 'Hectáreas',
    'colheita.col.medicao': 'Medición',
    'colheita.col.lancamento': 'Registrada el',
    'colheita.col.dupla': 'Dupla',

    'colheita.alertas.title': 'Mediciones que no coinciden con el Frente',
    'colheita.alertas.count_one': '{{count}} alerta',
    'colheita.alertas.count_other': '{{count}} alertas',
    'colheita.alertas.conferidas_one': 'en {{count}} medición verificada',
    'colheita.alertas.conferidas_other': 'en {{count}} mediciones verificadas',
    'colheita.alertas.hint': 'Cada medición de Protheus contra el Frente de Trabajo: las fechas por la primera y la última programación de cosecha del operador en el contrato, y las hectáreas por la Maquinaria. Sin período: la alerta desaparece cuando se corrige Protheus o el Frente',
    'colheita.alertas.vazio': 'Ninguna medición difiere del Frente',
    'colheita.alertas.grupo.protheus': 'Protheus',
    'colheita.alertas.grupo.hub': 'Frente de Trabajo',
    'colheita.alertas.colAlerta': 'Alerta',
    'colheita.alertas.colSituacao': 'Estado del frente',
    'colheita.alertas.colHubInicio': 'Primera',
    'colheita.alertas.colHubFim': 'Última',
    'colheita.alertas.tipo.sem_programacao': 'Sin programación en el Frente',
    'colheita.alertas.tipo.data_diverge': 'Fecha divergente',
    'colheita.alertas.tipo.fora_do_local': 'Máquina fuera del local',
    'colheita.alertas.tipo.hectares_diverge': 'Hectáreas diferentes',
    'colheita.alertas.tipo.sem_frente': 'Sin frente en el HUB',
    'colheita.alertas.hint.sem_programacao': 'La medición es de un contrato del HUB, pero ninguna programación de cosecha de ese contrato en el Frente tiene este operador ni esta máquina',
    'colheita.alertas.hint.data_diverge': 'La fecha inicial o final de la medición en Protheus no es el día de la primera o la última programación de cosecha del operador en este contrato en el Frente. La fecha que diverge queda en rojo. Cuando el nombre del operador no coincide, vale la máquina',
    'colheita.alertas.hint.fora_do_local': 'La última posición del rastreador de la máquina supera en más de 10 km el radio del local del último viaje de Transporte de Máquina. La posición de antes de la llegada no cuenta',
    'colheita.alertas.hint.hectares_diverge': 'Las hectáreas de la medición en Protheus no coinciden con las de la misma máquina y el mismo operador en la Maquinaria del Frente, y las mediciones de la misma línea suman. La medición con 0 hectáreas solo alerta cuando el frente está Finalizado o Finalizado con pendiente',
    'colheita.alertas.hint.sem_frente': 'Medición con fecha inicial desde el 16/10/2026 que no se vincula a ningún frente del HUB, ni por el pivote ni por la planilla del ERP',
    'colheita.alertas.maquinas.title': 'Máquinas fuera del local del último viaje',
    'colheita.alertas.maquinas.hint': 'La posición del rastreador contra el destino del último viaje concluido, el mismo de la Ubicación actual de la máquina en el Dashboard. Alerta cuando la máquina supera en más de 10 km el radio del local',
    'colheita.alertas.maquinas.vazio': 'Ninguna máquina lejos del local del último viaje',
    'colheita.alertas.maquinas.colMaquina': 'Máquina',
    'colheita.alertas.maquinas.colLocal': 'Local del último viaje',
    'colheita.alertas.maquinas.colChegada': 'Llegada',
    'colheita.alertas.maquinas.colDistancia': 'Distancia',
    'colheita.alertas.maquinas.colPosicao': 'Posición del rastreador',
    'colheita.alertas.maquinas.colCliente': 'Cliente',
    'colheita.alertas.maquinas.colViagem': 'Viaje',
    'colheita.alertas.maquinas.km': '{{km}} km',
    'colheita.alertas.maquinas.raio': 'Radio del local {{km}} km',
    'colheita.alertas.maquinas.rodando': 'Fue rodando',
    'colheita.alertas.maquinas.mapa': 'Mapa',
    'colheita.alertas.maquinas.rastreador.ssx': 'SSX',
    'colheita.alertas.maquinas.rastreador.truckscontrol': 'Trucks Control',
    'colheita.alertas.maquinas.rastreador.aldeia': 'Aldeia',
    'colheita.alertas.grupo.hectares': 'Hectáreas',
    'colheita.alertas.colHaProtheus': 'Protheus',
    'colheita.alertas.colHaFrente': 'Frente',
    'colheita.alertas.medicoesSomadas_one': '{{count}} medición suma {{total}}',
    'colheita.alertas.medicoesSomadas_other': '{{count}} mediciones suman {{total}}',
    'colheita.alertas.linhasSomadas_one': '{{count}} línea de Maquinaria',
    'colheita.alertas.linhasSomadas_other': '{{count}} líneas de Maquinaria',
    'colheita.alertas.casadoPor.operador': 'Programaciones encontradas por el nombre del operador',
    'colheita.alertas.casadoPor.maquina': 'Programaciones encontradas por el código de la máquina, porque el nombre del operador no coincidió',
    'colheita.alertas.programacoes_one': '{{count}} programación',
    'colheita.alertas.programacoes_other': '{{count}} programaciones',
  },
}
